import index from "./eventList.vue";
export default index;
